<template>
  <div id="container">
    <v-dialog v-model="enable" max-width="500" persistent>
      <v-card style="text-align:center">
        <div class="py-2">
          
            <div class="backcolor__icon">
              <v-icon class="icon"  color="red">warning</v-icon>

            </div>
          </div>

        <v-card-title
          class="center_btns"
          style="font-weight:700; font-size:17px"
          primary-title
        >
          {{ title }}
        </v-card-title>

        <v-layout row wrap class="mb-3">
          <v-flex style="text-align:left" offset-sm2 sm8>
            <span>Contraseña</span>

            <!-- <v-text-field
              class="border-container"
              hide-details
              solo
              required
              :error-messages="passwordErrors"
              flat
              rounded
              clearable
              type="password"
              v-model="$v.user.password.$model"
               @keydown.space="preventLeadingSpace"
            ></v-text-field> -->
            <v-text-field
              @keydown.space="preventLeadingSpace"
              v-model="$v.user.password.$model"
              clearable
              required
              class="border-container"
              flat
              rounded
              solo
              hide-details
            />

            <span class="error-pass">{{ passwordErrors }}</span>
            <v-layout>
              <v-flex xs12 text-xs-center>
                <v-alert
                  style="border-radius: 10px;"
                  :value="errors.eLogin"
                  type="error"
                  >{{ errors.eMessage }}</v-alert
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-card-actions class="center_btns">
          <v-btn class="custom-border" @click="cancel" depressed outline
            >Cancelar</v-btn
          >
          <v-btn
            class="custom-border "
          
            style="font-size:14px;background:#f44336;color:#fff"
            depressed
            @click="ok"
            >Eliminar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import alert from '../../../../Dialogs/Alert.vue'
export default {
  props: ['value', 'title', 'description', 'errors'],
  validations: {
    user: {
      password: { required },
    },
  },
  components: {
    alert,
  },
  data() {
    return {
      user: {
        password: '',
      },
      enable: this.value,
    }
  },
  watch: {
    value() {
      this.enable = this.value
    },
  },
  methods: {
    cancel() {
      this.$emit('input', !this.value)
      this.$emit('desition', false)
      this.user.password = ''
    },
    ok() {
      this.$v.user.$touch()
      if (this.$v.user.$invalid) {
        return
      }
      this.$emit('input', !this.value)
      this.$emit('desition', true, this.user.password)

      this.user = {
        password: '',
      }
    },
    preventLeadingSpace(e) {
      // Prevenr whiteSpace
      if (!e.target.value) e.preventDefault()
      else if (e.target.value[0] == ' ')
        e.target.value = e.target.value.replace(/^\s*/, '')
    },
  },
  computed: {
    passwordErrors() {
      if (!this.$v.user.password.$dirty) return ''
      if (!this.user.password) {
        return 'Contraseña Obligatoria'
      }
      return ''
    },
  },
}
</script>

<style scoped>
.custom-border {
  border-radius: 0.5rem;
  text-transform: capitalize;
  border-color: #ccc !important;
}
.center_btns {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
  padding: 0;
}
::v-deep .v-input__slot {
  min-height: unset;
  height: 35px;
}
::v-deep .v-text-field.v-text-field--solo .v-input__control {
  min-height: 30px;
  padding: 0;
}
.error-pass {
  color: #f44336;
}
button{
  text-transform: capitalize;
}

.backcolor__icon{
  background-color: #FEE2E2;
  display: flex;
  align-items: center;
  justify-content: center;
   border-radius: 50%;
   width: 50px;
   height: 50px;
  margin: auto;
}
.icon{
   font-size: 30px;
   border: none;

}
</style>
